import * as Schema from "effect/Schema";
import { EmailAddress, EmailMember, MailIdentifier } from "./email.ts";

export const RelayEmailAction = Schema.Struct({
  action: Schema.Literals(["status", "members", "ensure", "access", "revoke", "delete"]),
  workspaceId: MailIdentifier,
  displayName: Schema.optionalKey(Schema.String.check(Schema.isMaxLength(150))),
  operationId: Schema.optionalKey(MailIdentifier),
  externalId: Schema.optionalKey(MailIdentifier),
  accessId: Schema.optionalKey(MailIdentifier),
});
export type RelayEmailAction = typeof RelayEmailAction.Type;
export const RelayEmailResult = Schema.Struct({
  configured: Schema.Boolean,
  domain: Schema.optionalKey(MailIdentifier),
  mailbox: Schema.optionalKey(
    Schema.Struct({ backend: MailIdentifier, externalId: MailIdentifier, address: EmailAddress }),
  ),
  access: Schema.optionalKey(
    Schema.Struct({ id: MailIdentifier, secret: Schema.RedactedFromValue(Schema.String) }),
  ),
  members: Schema.optionalKey(Schema.Array(EmailMember)),
});
export type RelayEmailResult = typeof RelayEmailResult.Type;
